export const MODALS_GETTERS_IS_OPEN = 'modals_getters_is_open'
export const MODALS_GETTERS_IS_NESTED = 'modals_getters_is_nested'

export const MODALS_MUTATION_TOGGLE_OPEN = 'modals_mutation_toggle_open'
